import { ANIMATION_DURATION, TRANSITION_DELAY } from '@/constants/register.contants'
import { Box, Grow, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React, { useEffect, useRef, useState } from 'react'

export const InterestInfoDisplay: React.FC<InterestInfoDisplayProps> = ({
  interests,
  additionalThoughts,
  onAnimationComplete,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const animationCompleteRef = useRef(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, TRANSITION_DELAY)

    return () => clearTimeout(timer)
  }, [])

  const handleEntered = () => {
    if (!animationCompleteRef.current) {
      animationCompleteRef.current = true
      setTimeout(onAnimationComplete, TRANSITION_DELAY)
    }
  }

  const selectedInterests = interests.filter((interest) => interest.selected)

  return (
    <Grow in={isVisible} timeout={ANIMATION_DURATION} onEntered={handleEntered}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mt: 1,
          mb: 2,
          ml: 'auto',
          width: '90%',
          borderRadius: 4,
          bgcolor: (theme) =>
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.secondary.main, 0.1)
              : alpha(theme.palette.secondary.light, 0.1),
        }}
      >
        {selectedInterests.length > 0 && (
          <Box>
            <Typography variant="body2" fontWeight="bold" gutterBottom>
              I'm interested in:
            </Typography>
            {selectedInterests.map((interest) => (
              <Typography key={interest.id} variant="body2" sx={{ pl: 1, mb: 0.5 }}>
                • {interest.label}
              </Typography>
            ))}
          </Box>
        )}

        {additionalThoughts && (
          <>
            <Typography variant="body2" fontWeight="bold" sx={{ mt: interests.length > 0 ? 2 : 0 }} gutterBottom>
              My additional thoughts:
            </Typography>
            <Typography variant="body2">{additionalThoughts}</Typography>
          </>
        )}
      </Paper>
    </Grow>
  )
}
